import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export class PaginatorI18n {

  constructor(private readonly translate: TranslateService) { }

  getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = this.translate.instant('paginator.items-per-page');
    paginatorIntl.nextPageLabel = this.translate.instant('paginator.next-page');
    paginatorIntl.previousPageLabel = this.translate.instant('paginator.previous-page');
    paginatorIntl.firstPageLabel = this.translate.instant('paginator.first-page');
    paginatorIntl.lastPageLabel = this.translate.instant('paginator.last-page');
    paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
    return paginatorIntl;
  }

  getRangeLabel(page: number, pageSize: number, length: number): string {
    const startItem = (page * pageSize) + 1;
    const endItem = (page + 1) * pageSize;
    const totalItems = length

    return this.translate.instant('paginator.range-page-2', { startItem, endItem: Math.min(endItem, totalItems), totalItems });

  }
}
